import { JSX } from "react";
import { QesIcon } from "@app/shared/icons/QESIcon";
import { QesIcons } from "@app/shared/icons/qesIcons";

export const niChangeArrowSize = "0.9em";

export type NetworkIntegrityChangeDirection = "decrease" | "no-change";

interface NetworkIntegrityChangeArrowProps {
  direction: NetworkIntegrityChangeDirection;
}

export const NetworkIntegrityChangeArrow = ({ direction }: NetworkIntegrityChangeArrowProps): JSX.Element => {
  const iconName = direction === "decrease" ? QesIcons.ArrowNarrowDown : QesIcons.ArrowsHorizontal;
  return (
    <>
      {" "}
      <QesIcon
        height={niChangeArrowSize}
        iconName={iconName}
        isDecorative
        width={niChangeArrowSize}
      />
    </>
  );
};
